import React from "react";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import { BASE_URL } from "utils/utils";
import Message from "views/admin/support/components/Message";

const SupportColumns = (refetch) => [
  {
    Header: "المستخدم",
    accessor: "user",
    Cell: ({ row }) => {
      return (
        <div className="flex items-center gap-2">
          <img
            src={
              row.original.user.photo
                ? `${BASE_URL}/${row.original?.user?.photo}`
                : profileImage
            }
            alt="avatar"
            className="h-10 w-10 rounded-full border border-gray-200"
            crossOrigin="anonymous"
          />
          <span>{row.original?.user?.name}</span>
        </div>
      );
    },
  },
  {
    Header: "الحالة",
    accessor: "active",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs ${
            row.values.user.active
              ? "bg-green-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {row.values.user.active ? "مفعل" : "غير مفعل"}
        </span>
      );
    },
  },
  {
    Header: "الرقم",
    accessor: "phoneNumber",
    Cell: ({ row }) => {
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`tel:${row.original.user.phoneNumber}`}
        >
          {row.original.user.phoneNumber}
        </a>
      );
    },
  },
  {
    Header: "التاريخ",
    accessor: "createdAt",
    Cell: ({ row }) => {
      const date = new Date(row.values.createdAt).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return <span>{date}</span>;
    },
  },
  {
    Header: "الرسالة",
    accessor: "message",
    Cell: ({ row }) => {
      return (
        <div className="flex flex-col gap-2">
          <Message data={row.original} refetch={refetch} />
        </div>
      );
    },
  },
];

export { SupportColumns };
